import React, { useState, useEffect } from 'react';
import './NewArrivals.css';
import { FaSearchPlus } from 'react-icons/fa';
import { collection, onSnapshot, query, orderBy, limit } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase/firebase-config';

const NewArrivals = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Sabit tasarım dizilimi kanka
  const designSizes = ['large', 'small', 'small', 'wide'];

  useEffect(() => {
    // Sadece son eklenen 4 ürünü çekiyoruz
    const q = query(
      collection(db, "products"), 
      orderBy("createdAt", "desc"), 
      limit(4) 
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc, index) => ({
        docId: doc.id,
        ...doc.data(),
        displaySize: designSizes[index] 
      }));
      setProducts(data);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div className="luxury-loader">Koleksiyon Hazırlanıyor...</div>;

  return (
    <section className="new-arrivals">
      <div className="arrivals-container">
        
        <div className="arrivals-header">
          <div className="header-text">
            <span className="gold-subtitle">Yeni Gelenler</span>
            <h2 className="arrival-title">Haftanın <em>Seçkisi</em></h2>
          </div>
          <p className="header-desc">
            Koleksiyonumuza yeni dahil olan, kondisyonu en yüksek ve 
            hikayesi en derin parçaları keşfedin.
          </p>
        </div>

        <div className="arrivals-grid">
          {products.map((item) => (
            <div key={item.docId} className={`arrival-card ${item.displaySize}`}>
              <div className="product-shape-container">
                <div className="product-img-wrapper">
                  <img src={item.img} alt={item.name} />
                  <div className="product-id-tag">#{item.id}</div>
                  <div className="product-hover-overlay">
                    <button 
                      className="luxury-view-btn"
                      onClick={() => navigate(`/urun/${item.docId}`)}
                    >
                      <FaSearchPlus /> DETAYLARI İNCELE
                    </button>
                  </div>
                </div>
              </div>
              <div className="product-info-minimal">
                <h3>{item.name}</h3>
                <div className="info-footer">
                   <span className="product-price-tag">{item.price}</span>
                   <div className="info-line"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="view-all-center">
          <button className="premium-outline-btn" onClick={() => navigate('/urunler')}>
            TÜMÜNÜ GÖR
          </button>
        </div>

      </div>
    </section>
  );
};

export default NewArrivals;